import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import PlaceholderDataService from './services/PlaceholderDataService';

// Initialize placeholder data if enabled
if (import.meta.env.VITE_USE_PLACEHOLDER_DATA === 'true') {
  PlaceholderDataService.initialize();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
